/* eslint-disable import/no-extraneous-dependencies */
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import AceEditor from 'react-ace';
import { toastr } from 'react-redux-toastr';
import Footer from 'components/Footer2';
import { BotsCreators } from '../../../store/actions/bots';
import { ChannelId } from '../../../util/channels';
import { UserActions } from '../../../store/actions/users';

import './ChannelBar.scss';
import ChannelBarItemSetup from './ChannelBarItemSetup';
import Toggle from '../../Elements/Toggle/Toggle';
import ChannelBarFab from './ChannelBarFab';

import 'ace-builds/src-noconflict/mode-javascript';
import 'ace-builds/src-noconflict/theme-kuroir';

class ChannelBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      channelCopy: undefined,
      tab: 'setup',
      barChannels: undefined,
      tamIcon: 80,
      tamIconChannel: 60,
    };
  }

  componentDidMount() {
    const {
      retrieveBotRequest,
      match: {
        params: { botid },
      },
    } = this.props;
    retrieveBotRequest(botid);
  }

  updateBarChannel = (channelId, checked) => {
    // console.log('updateBarChannel: ', channelId, ' checked: ', checked);
    const { barChannels } = this.state;
    const { bot } = this.props;
    let channel = bot.channels.find(
      (i) => i.channelId === ChannelId.ChannelsBar
    );
    const settings = channel && channel.settings ? { ...channel.settings } : {};
    const barChannelsTemp = barChannels || settings.barChannels || [];
    const barCopy = [...barChannelsTemp].filter((i) => i !== channelId);
    if (checked) {
      barCopy.push(channelId);
    }
    barCopy.sort((a, b) => {
      if (b === ChannelId.WhatsApp) {
        return -1;
      }
      return 0;
    });
    if (!channel) {
      channel = { channelId: ChannelId.ChannelsBar };
      channel.settings = {};
    }
    channel.settings.barChannels = barCopy;
    this.setState({ barChannels: barCopy, channel });
  };

  onBotFabChanged = (files, isOpen) => {
    if (files && files.length > 0) {
      const file = files[0];
      if (!file.type) {
        toastr.error('Erro', 'Não foi possível identificar o tipo do arquivo.');
      } else if (
        file.type !== 'image/png' &&
        file.type !== 'image/jpg' &&
        file.type !== 'image/jpeg'
      ) {
        toastr.error(
          'Erro',
          'O arquivo precisa ser em um desses formatos: .png, .jpg, .jpeg'
        );
      } else {
        const reader = new FileReader();
        reader.onload = (e) => {
          const image = new Image();
          image.src = e.target.result;
          image.onload = () => {
            if (image.width !== 80 || image.height !== 80) {
              toastr.error(
                'Erro',
                `A imagem deve ser 80x80. A imagem escolhida tem ${image.width}x${image.height}`
              );
            } else {
              const channel = this.getChannelCopy();
              if (isOpen) {
                channel.settings.barOpen = e.target.result;
              } else {
                channel.settings.barClose = e.target.result;
              }
              this.setState({ channelCopy: channel });
            }
          };
        };
        reader.readAsDataURL(file);
      }
    }
  };

  onBarOpen = (files) => {
    this.onBotFabChanged(files, true);
  };

  onBarClose = (files) => {
    this.onBotFabChanged(files, false);
  };

  setIconBar = (files, type) => {
    if (files && files.length > 0) {
      const file = files[0];
      if (!file.type) {
        toastr.error('Erro', 'Não foi possível identificar o tipo do arquivo.');
      } else if (
        file.type !== 'image/png' &&
        file.type !== 'image/jpg' &&
        file.type !== 'image/jpeg'
      ) {
        toastr.error(
          'Erro',
          'O arquivo precisa ser em um desses formatos: .png, .jpg, .jpeg'
        );
      } else {
        const reader = new FileReader();
        reader.onload = (e) => {
          const image = new Image();
          image.src = e.target.result;
          image.onload = () => {
            if (image.width !== 80 || image.height !== 80) {
              toastr.error(
                'Erro',
                `A imagem deve ser 80x80. A imagem escolhida tem ${image.width}x${image.height}`
              );
            } else {
              const channel = this.getChannelCopy();
              switch (type) {
                case 'webchat':
                  channel.settings.iconWebchat = e.target.result;
                  break;
                case 'whatsapp':
                  channel.settings.iconWhatsapp = e.target.result;
                  break;
                case 'facebookmessenger':
                  channel.settings.iconFacebookMessenger = e.target.result;
                  break;
                case 'email':
                  channel.settings.iconEmail = e.target.result;
                  break;
                default:
              }
              this.setState({ channelCopy: channel });
            }
          };
        };
        reader.readAsDataURL(file);
      }
    }
  };

  getChannelCopy = () => {
    const { channelCopy } = this.state;
    if (channelCopy) {
      return channelCopy;
    }
    const { bot } = this.props;
    const channel = bot.channels.find(
      (i) => i.channelId === ChannelId.ChannelsBar
    );

    return {
      channelId: ChannelId.ChannelsBar,
      settings: channel && channel.settings ? { ...channel.settings } : {},
      isActive: channel ? channel.isActive : false,
    };
  };

  onChannelAddUrl = (channelChanged, url) => {
    const channel = this.getChannelCopy();
    switch (channelChanged) {
      case 'email':
        channel.settings.urlEmail = url;
        break;
      default:
    }
    this.setState({ channelCopy: channel });
  };

  onChannelAddUrl = (channelChanged, url) => {
    const channel = this.getChannelCopy();
    switch (channelChanged) {
      case 'email':
        channel.settings.urlEmail = url;
        break;
      default:
    }
    this.setState({ channelCopy: channel });
  };

  onChannelActiveChanged = () => {
    const channelCopy = this.getChannelCopy();
    channelCopy.isActive = !channelCopy.isActive;
    this.updateChannelState(channelCopy);
  };

  updateChannelState = (channelCopy) => {
    this.setState({ channelCopy });
  };

  updateChannel = (channelCopy) => {
    const {
      updateBotRequest,
      bot,
      match: {
        params: { botid },
      },
    } = this.props;

    const payload = {
      channels: [
        ...bot.channels.filter((i) => i.channelId !== ChannelId.ChannelsBar),
      ],
    };

    const { barChannels, tamIcon, tamIconChannel } = this.state;

    if (!channelCopy) {
      channelCopy = {};
      channelCopy.settings = {};
    }
    channelCopy.settings = channelCopy.settings
      ? {
          ...channelCopy.settings,
          iconSize: tamIcon,
          iconSizeChannels: tamIconChannel,
        }
      : {};
    channelCopy.settings.barChannels = barChannels;
    payload.channels.push(channelCopy);

    updateBotRequest(botid, payload, true);
  };

  tamIconFunc = (fontBalao, fontChannel) => {
    this.setState({
      tamIcon: fontBalao,
      tamIconChannel: fontChannel,
    });
  };

  componentDidUpdate(prevProps) {
    if (prevProps.bot !== this.props.bot) {
      const { bot } = this.props;

      const channel = bot.channels.find(
        (i) => i.channelId === ChannelId.ChannelsBar
      );

      if (channel) {
        this.addInitalState(channel);
      }
    }
  }

  addInitalState(channel) {
    this.setState({
      barChannels: channel.settings.barChannels,
      tamIcon: Number(channel.settings.iconSize),
      tamIconChannel: Number(channel.settings.iconSizeChannels),
    });
  }

  render() {
    const { i18n, bot, user } = this.props;
    const { channelCopy, tab, barChannels, tamIcon, tamIconChannel } =
      this.state;

    if (!bot || !bot._id) {
      return null;
    }

    const channel = channelCopy ||
      bot.channels.find((i) => i.channelId === ChannelId.ChannelsBar) || {
        channelId: ChannelId.ChannelsBar,
      };

    if (!channel.settings) {
      channel.settings = {};
    }

    channel.settings.barOpen =
      channel.settings.barOpen ||
      'data:image/png;base64,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';
    channel.settings.barClose =
      channel.settings.barClose ||
      'data:image/png;base64,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';
    channel.settings.iconWhatsapp =
      channel.settings.iconWhatsapp ||
      'data:image/png;base64,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';
    channel.settings.iconFacebookMessenger =
      channel.settings.iconFacebookMessenger ||
      'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iNDMiIGhlaWdodD0iNDMiIHZpZXdCb3g9IjAgMCA0MyA0MyI+CiAgPGRlZnM+CiAgICA8bGluZWFyR3JhZGllbnQgaWQ9ImxpbmVhci1ncmFkaWVudCIgeDE9IjAuNSIgeDI9IjAuNSIgeTI9IjEiIGdyYWRpZW50VW5pdHM9Im9iamVjdEJvdW5kaW5nQm94Ij4KICAgICAgPHN0b3Agb2Zmc2V0PSIwIiBzdG9wLWNvbG9yPSIjMDBiMmZmIi8+CiAgICAgIDxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzAwNmFmZiIvPgogICAgPC9saW5lYXJHcmFkaWVudD4KICA8L2RlZnM+CiAgPGcgaWQ9IkZhY2Vib29rX01lc3Nlbmdlcl80X0xvZ28iIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xNSAtMTEuNSkiPgogICAgPHBhdGggaWQ9IkJ1YmJsZV9Tb2xpZF8zXyIgZD0iTTM2LjUsMTEuNUMyNC4zODcsMTEuNSwxNSwyMC4zNzMsMTUsMzIuMzU2YTIwLjQsMjAuNCwwLDAsMCw2Ljc1MywxNS40MjYsMS43MzIsMS43MzIsMCwwLDEsLjU4LDEuMjI0bC4xMTcsMy44MjRhMS43MjMsMS43MjMsMCwwLDAsMi40MTQsMS41MjNsNC4yNjUtMS44ODJhMS43MTYsMS43MTYsMCwwLDEsMS4xNDYtLjA4NywyMy4zODUsMjMuMzg1LDAsMCwwLDYuMjI1LjgyNmMxMi4xMTMsMCwyMS41LTguODczLDIxLjUtMjAuODU2UzQ4LjYxMywxMS41LDM2LjUsMTEuNVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMCkiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZmlsbD0idXJsKCNsaW5lYXItZ3JhZGllbnQpIi8+CiAgICA8cGF0aCBpZD0iQm9sdF80XyIgZD0iTTIwOS45LDM1OC41NzNsNi4zMTYtMTAuMDE5YTMuMjI4LDMuMjI4LDAsMCwxLDQuNjYzLS44NjFsNS4wMjIsMy43NjhhMS4yOTEsMS4yOTEsMCwwLDAsMS41NTMsMGw2Ljc4My01LjE0OGExLjAyLDEuMDIsMCwwLDEsMS40NzksMS4zNThMMjI5LjQsMzU3LjY4MWEzLjIyOCwzLjIyOCwwLDAsMS00LjY2My44NjFsLTUuMDIyLTMuNzY4YTEuMjkxLDEuMjkxLDAsMCwwLTEuNTUzLDBsLTYuNzg3LDUuMTUyQTEuMDIsMS4wMiwwLDAsMSwyMDkuOSwzNTguNTczWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTE4Ni4zMDQgLTMyMC4xMTcpIiBmaWxsPSIjZmZmIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KICA8L2c+Cjwvc3ZnPgo=';
    channel.settings.iconWebchat =
      channel.settings.iconWebchat ||
      'data:image/png;base64,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';
    channel.settings.iconEmail =
      channel.settings.iconEmail ||
      'data:image/svg+xml;base64,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';

    const channelBarChannels =
      barChannels ||
      (channel && channel.settings && channel.settings.barChannels
        ? channel.settings.barChannels
        : []);

    channel.settings.barChannels = channelBarChannels;

    return (
      <div className="row linha-conteudo">
        <div
          className="col-md-12 conteudo-iniciar"
          style={{ marginBottom: '2rem' }}
        >
          <div className="container">
            <div className="row justify-content-center">
              {/* CARD COLUMN */}
              <div className="col-md-7">
                <span className="channel-title">
                  {i18n.t('Configurar Barra de Canais')}
                </span>
                <div className="card mt-2">
                  <div className="card-body card-body-channels-bar">
                    <div>
                      {/* Tabs */}
                      <ul className="nav nav-tabs">
                        <li className="nav-item">
                          <a
                            className="nav-link active"
                            role="tab"
                            data-toggle="tab"
                            href="#tab-1"
                            onClick={() => this.setState({ tab: 'setup' })}
                          >
                            Setup
                          </a>
                        </li>
                        <li className="nav-item">
                          <a
                            className="nav-link"
                            role="tab"
                            data-toggle="tab"
                            href="#tab-2"
                            onClick={() => this.setState({ tab: 'publish' })}
                          >
                            Publicação
                          </a>
                        </li>
                        {/* <li className="nav-item"><a className="nav-link" role="tab" data-toggle="tab" href="#tab-3">Avançado</a></li> */}
                      </ul>
                      {/* Tabs Content */}
                      <div className="tab-content mt-3">
                        {/* Tab Setup */}
                        <div
                          className="tab-pane active"
                          role="tabpanel"
                          id="tab-1"
                        >
                          {/* Tab Setup - Nome da barra */}
                          <div className="row">
                            <div className="col-md-6 p-0 icon-format-block">
                              <img src={channel.settings.barOpen} alt="" />
                              <div>
                                <p>{i18n.t('Ícone abrir')}</p>
                                <input
                                  id="acesso-imagem-file-input"
                                  className="setup-bot-fab-input"
                                  type="file"
                                  accept="image/png"
                                  onChange={(e) =>
                                    this.onBarOpen(e.target.files)
                                  }
                                  ref={(input) => (this.barOpenfile = input)}
                                />
                                <button
                                  type="button"
                                  className="btn btn-outline-primary btn-upload"
                                  onClick={() => {
                                    this.barOpenfile.click();
                                  }}
                                >
                                  Upload de Arquivo
                                </button>
                                <p className="italic">
                                  {i18n.t('Formatos')}:{' '}
                                  {i18n.t('Formatos: .png, .jpg, .jpeg')}
                                </p>
                                <p className="italic">
                                  {i18n.t(`Dimensão: 80x80px`)}
                                </p>
                              </div>
                            </div>
                            <div className="col-md-6 p-0 icon-format-block">
                              <img src={channel.settings.barClose} alt="" />
                              <div>
                                <p>{i18n.t('Ícone fechar')}</p>
                                <input
                                  id="acesso-imagem-file-input"
                                  className="setup-bot-fab-input"
                                  type="file"
                                  accept="image/png"
                                  onChange={(e) =>
                                    this.onBarClose(e.target.files)
                                  }
                                  ref={(input) => (this.barClosefile = input)}
                                />
                                <button
                                  type="button"
                                  className="btn btn-outline-primary btn-upload"
                                  onClick={() => {
                                    this.barClosefile.click();
                                  }}
                                >
                                  Upload de Arquivo
                                </button>
                                <p className="italic">
                                  {i18n.t('Formatos')}:{' '}
                                  {i18n.t('Formatos: .png, .jpg, .jpeg')}
                                </p>
                                <p className="italic">
                                  {i18n.t('Dimensão: 80x80px')}
                                </p>
                              </div>
                            </div>
                            <div className="container-tamanho-icone">
                              Tamanho do ícone
                              <div className="container-valor-tamanho-icon">
                                <div
                                  className={tamIcon === 55 ? 'activeFont' : ''}
                                  onClick={() => this.tamIconFunc(55, 50)}
                                >
                                  55/50
                                </div>
                                <div
                                  className={tamIcon === 60 ? 'activeFont' : ''}
                                  onClick={() => this.tamIconFunc(60, 50)}
                                >
                                  60/50
                                </div>
                                <div
                                  className={tamIcon === 70 ? 'activeFont' : ''}
                                  onClick={() => this.tamIconFunc(70, 55)}
                                >
                                  70/55
                                </div>
                                <div
                                  className={
                                    Number(tamIcon) === 80 ? 'activeFont' : ''
                                  }
                                  onClick={() => this.tamIconFunc(80, 60)}
                                >
                                  80/60
                                </div>
                              </div>
                            </div>
                            <hr />
                            <div className="container-channels-all">
                              <p className="text-title-barra-canais">
                                Selecione os canais que já foram publicados para
                                aparecerem em sua barra de canais
                              </p>
                              <div className="container-channel-bar-item-setup">
                                <ChannelBarItemSetup
                                  img={channel.settings.iconWhatsapp}
                                  label={i18n.t('WhatsApp')}
                                  checked={
                                    channelBarChannels.find(
                                      (i) => i === ChannelId.WhatsApp
                                    ) !== undefined
                                  }
                                  onChange={(e) => {
                                    this.updateBarChannel(
                                      ChannelId.WhatsApp,
                                      e.target.checked
                                    );
                                  }}
                                />
                                <input
                                  id="acesso-imagem-file-input"
                                  className="setup-bot-fab-input"
                                  type="file"
                                  accept="image/png"
                                  onChange={(e) =>
                                    this.setIconBar(e.target.files, 'whatsapp')
                                  }
                                  ref={(input) =>
                                    (this.setIconBarWhatsapp = input)
                                  }
                                />
                                <button
                                  type="button"
                                  className="btn btn-outline-primary btn-upload"
                                  onClick={() =>
                                    this.setIconBarWhatsapp.click()
                                  }
                                >
                                  mudar ícone
                                </button>
                              </div>
                              <div className="container-channel-bar-item-setup">
                                <ChannelBarItemSetup
                                  img={channel.settings.iconFacebookMessenger}
                                  label={i18n.t('Messenger')}
                                  iconSize={22}
                                  checked={
                                    channelBarChannels.find(
                                      (i) => i === ChannelId.FacebookMessenger
                                    ) !== undefined
                                  }
                                  onChange={(e) => {
                                    this.updateBarChannel(
                                      ChannelId.FacebookMessenger,
                                      e.target.checked
                                    );
                                  }}
                                />
                                <input
                                  id="acesso-imagem-file-input"
                                  className="setup-bot-fab-input"
                                  type="file"
                                  accept="image/png"
                                  onChange={(e) =>
                                    this.setIconBar(
                                      e.target.files,
                                      'facebookmessenger'
                                    )
                                  }
                                  ref={(input) =>
                                    (this.setIconBarFacebookMessenger = input)
                                  }
                                />
                                <button
                                  type="button"
                                  className="btn btn-outline-primary btn-upload"
                                  onClick={() =>
                                    this.setIconBarFacebookMessenger.click()
                                  }
                                >
                                  mudar ícone
                                </button>
                              </div>
                              <ChannelBarItemSetup
                                img={require('../../../assets/images/icon_service_telegram.svg')}
                                label={i18n.t('Telegram')}
                                iconSize={22}
                                disabled
                                onChange={() => {}}
                              />
                              <div className="container-channel-bar-item-setup">
                                <ChannelBarItemSetup
                                  img={channel.settings.iconEmail}
                                  label={i18n.t('Email')}
                                  iconSize={22}
                                  checked={
                                    channelBarChannels.find(
                                      (i) => i === ChannelId.Email
                                    ) !== undefined
                                  }
                                  onChange={(e) => {
                                    this.updateBarChannel(
                                      ChannelId.Email,
                                      e.target.checked
                                    );
                                  }}
                                />
                                <input
                                  id="acesso-imagem-file-input"
                                  className="setup-bot-fab-input"
                                  type="file"
                                  accept="image/png"
                                  onChange={(e) =>
                                    this.setIconBar(e.target.files, 'email')
                                  }
                                  ref={(input) =>
                                    (this.setIconBarEmail = input)
                                  }
                                />

                                <input
                                  type="text"
                                  name="url"
                                  className="input-email-barra-canais"
                                  id="urlEmail"
                                  defaultValue={channel.settings.urlEmail}
                                  onChange={(e) => {
                                    this.onChannelAddUrl(
                                      'email',
                                      e.target.value
                                    );
                                  }}
                                />

                                <button
                                  type="button"
                                  className="btn btn-outline-primary btn-upload"
                                  onClick={() => this.setIconBarEmail.click()}
                                >
                                  mudar ícone
                                </button>
                              </div>
                              <div className="container-channel-bar-item-setup">
                                <ChannelBarItemSetup
                                  img={channel.settings.iconWebchat}
                                  label={i18n.t('Webchat')}
                                  iconSize={22}
                                  checked={
                                    channelBarChannels.find(
                                      (i) => i === ChannelId.WebChat
                                    ) !== undefined
                                  }
                                  onChange={(e) => {
                                    this.updateBarChannel(
                                      ChannelId.WebChat,
                                      e.target.checked
                                    );
                                  }}
                                />
                                <input
                                  id="acesso-imagem-file-input"
                                  className="setup-bot-fab-input"
                                  type="file"
                                  accept="image/png"
                                  onChange={(e) =>
                                    this.setIconBar(e.target.files, 'webchat')
                                  }
                                  ref={(input) =>
                                    (this.setIconBarWebchat = input)
                                  }
                                />
                                <button
                                  type="button"
                                  className="btn btn-outline-primary btn-upload"
                                  onClick={() => this.setIconBarWebchat.click()}
                                >
                                  mudar ícone
                                </button>
                              </div>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-md-12 mt-2">
                              <div className="float-left">
                                <Toggle
                                  disabled={
                                    user?.selectedCompany?.claim?.name ===
                                    'Viewer'
                                  }
                                  checked={channel ? channel.isActive : false}
                                  onChange={this.onChannelActiveChanged}
                                  identifier="active-channel"
                                />
                                <div style={{ marginTop: 8, width: 200 }}>
                                  <span>{i18n.t('Ativar canal')}</span>
                                </div>
                              </div>
                              <div className="float-right">
                                <button
                                  type="button"
                                  disabled={
                                    user?.selectedCompany?.claim?.name ===
                                    'Viewer'
                                  }
                                  className="btn btn-primary"
                                  onClick={() => this.updateChannel(channel)}
                                >
                                  {i18n.t('salvar')}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Tab Publicação */}
                        <div className="tab-pane" role="tabpanel" id="tab-2">
                          {/* Tab Setup - Nome da barra */}
                          <div className="row">
                            <div className="col-md-12">
                              <AceEditor
                                placeholder=""
                                mode="javascript"
                                theme="kuroir"
                                name="response-format"
                                disabled
                                onChange={() => {}}
                                className="response-editor-ace"
                                fontSize={12}
                                showPrintMargin
                                showGutter={false}
                                highlightActiveLine={false}
                                readOnly
                                value={`
<!-- HEAD -->
<link rel="stylesheet" href="${process.env.REACT_APP_CDN_URL}/cdn/widget_v2/widget.css" />
<link rel="stylesheet" href="${process.env.REACT_APP_CDN_URL}/cdn/widget_v2/webchat.v2.css" />
<script src="${process.env.REACT_APP_CDN_URL}/cdn/libs/showdown.min.js"></script>
<script src="${process.env.REACT_APP_CDN_URL}/cdn/libs/axios.js"></script>
<script src="${process.env.REACT_APP_CDN_URL}/cdn/libs/socket.io.js"></script>
<script src="${process.env.REACT_APP_CDN_URL}/cdn/widget_v2/widget.js"></script>
<meta charset="UTF-8">

<!-- Webchat em Full Screen -->
<!-- <link rel="stylesheet" href="${process.env.REACT_APP_CDN_URL}/cdn/widget/widget.css" />
<script src="${process.env.REACT_APP_CDN_URL}/cdn/libs/showdown.min.js"></script>
<script src="${process.env.REACT_APP_CDN_URL}/cdn/libs/axios.js"></script>
<script src="${process.env.REACT_APP_CDN_URL}/cdn/libs/socket.io.js"></script>
<script src="${process.env.REACT_APP_CDN_URL}/cdn/widget/widget.js"></script> -->

<!-- BODY -->
<script>
    (function () {
        window.onload = function () {
            new BoteriaChat().withAppKey('${bot._id}')
        }
    })()
</script>`}
                                setOptions={{
                                  enableBasicAutocompletion: false,
                                  enableLiveAutocompletion: false,
                                  enableSnippets: false,
                                  showLineNumbers: false,
                                  tabSize: 2,
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* PRE VISUALIZAÇÃO */}
              <div className="col-md-2">
                <span className="channel-subtitle" hidden={tab !== 'setup'}>
                  {i18n.t('Pré visualização')}
                </span>
                <ChannelBarFab
                  tamIcon={tamIcon}
                  tamIconChannel={tamIconChannel}
                  channel={channel}
                  hidden={tab !== 'setup'}
                />
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  bot: state.bots.bot,
  user: state.users.signedUser,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...BotsCreators, ...UserActions }, dispatch);

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ChannelBar))
);
